import Card from "react-bootstrap/Card";
import classes from "./UserCard.module.css";
import { epochToDateTime } from "../../commons/LaUtils";

type UserCardProps = {
  userId: string;
  email: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  about: string;
  activated?: boolean;
  role?: string;
  createdOn?: number;
  lastUpdatedOn?: number;
  version?: number;
};

const UserCard = (props: UserCardProps) => {

  return (
    <>
      <Card className={`${classes.element}`}>
        <Card.Body>
          <Card.Title className="mb-1">
            <div className={classes.elementTitle}>
              {props.email + " (" + props.userId + ")"}
            </div>
          </Card.Title>
          <>
            <div>
              {"Created on: " + (props.createdOn ? epochToDateTime(props.createdOn) : undefined)}
            </div>
            <div>
              {"Display name: " + props.displayName}
            </div>
            <div>
              {"First name: " + props.firstName}
            </div>
            <div>
              {"Last name: " + props.lastName}
            </div>
            <div>
              {"About: " + props.about}
            </div>
            <div>
              {"Activated: " + props.activated}
            </div>
            <div>
              {"role: " + props.role}
            </div>
            <div>
              {"Last updated on: " + (props.lastUpdatedOn ? epochToDateTime(props.lastUpdatedOn) : undefined)}
            </div>
            <div>
              {"Version: " + props.version}
            </div>
          </>
        </Card.Body>
      </Card>
    </>
  );
};

export default UserCard;
